import { QUERY_KEYS } from "library/shared";
import { TaxonomyApiResponse } from "library/types";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import api from "service/api";

const getTaxonomies = async (): Promise<TaxonomyApiResponse> => {
  const response = await api.get(`/taxonomy`);
  // API returns the taxonomy groups directly at the top level
  return response.data;
};

export function useGetTaxonomies(
  enabled = true
): UseQueryResult<TaxonomyApiResponse> {
  return useQuery<TaxonomyApiResponse, Error>({
    queryKey: [QUERY_KEYS.taxonomies],
    queryFn: getTaxonomies,
    enabled: enabled,
    staleTime: Infinity, // Taxonomies are reference data - never consider stale
    gcTime: 24 * 60 * 60 * 1000, // Keep in cache for 24 hours (renamed from cacheTime)
    refetchOnMount: false, // Don't refetch if data is already in cache
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
  });
}
